"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserAuthority = void 0;
var client_1 = require("@apollo/client");
var react_1 = require("react");
var QUERY_USER_AUTHORITIES = client_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query UserAuthoritiesQuery {\n    viewer {\n      id\n      acUser {\n        id\n        currentAuthorities {\n          id\n          roleName\n          userAvailabilityFlag\n          userReferabilityFlag\n          userEditabilityFlag\n          userDataCreateFlag\n          userDataModifyFlag\n          userDataRemoveFlag\n        }\n      }\n    }\n  }\n"], ["\n  query UserAuthoritiesQuery {\n    viewer {\n      id\n      acUser {\n        id\n        currentAuthorities {\n          id\n          roleName\n          userAvailabilityFlag\n          userReferabilityFlag\n          userEditabilityFlag\n          userDataCreateFlag\n          userDataModifyFlag\n          userDataRemoveFlag\n        }\n      }\n    }\n  }\n"])));
var useUserAuthority = function (roleName) {
    var _a = __read(react_1.useState({
        hasEdit: false,
        hasCreate: false,
        hasModify: false,
        hasRemove: false,
        hasReadPersonal: false,
    }), 2), userAuthority = _a[0], setUserAuthority = _a[1];
    var loading = client_1.useQuery(QUERY_USER_AUTHORITIES, {
        onCompleted: function (data) {
            var _a, _b, _c;
            var authority = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.viewer) === null || _a === void 0 ? void 0 : _a.acUser) === null || _b === void 0 ? void 0 : _b.currentAuthorities) === null || _c === void 0 ? void 0 : _c.find(function (it) { return it.roleName === roleName; });
            if (authority) {
                setUserAuthority({
                    hasEdit: authority.userAvailabilityFlag === 1 && authority.userEditabilityFlag === 1,
                    hasCreate: authority.userAvailabilityFlag === 1 && authority.userDataCreateFlag === 1,
                    hasModify: authority.userAvailabilityFlag === 1 && authority.userDataModifyFlag === 1,
                    hasRemove: authority.userAvailabilityFlag === 1 && authority.userDataRemoveFlag === 1,
                    hasReadPersonal: authority.userAvailabilityFlag === 1 && authority.userReferabilityFlag === 1,
                });
            }
        },
    }).loading;
    return { userAuthority: userAuthority, loading: loading };
};
exports.useUserAuthority = useUserAuthority;
var templateObject_1;
//# sourceMappingURL=UseUserAuthority.js.map